import { z } from 'zod'

export const BackgroundSchema = z.object({
  id: z.string(),
  name: z.string(),
  isSystem: z.boolean(),
  contentType: z.string(),
  sizeBytes: z.number().int().nonnegative(),
  createdAt: z.string(),
})
export type Background = z.infer<typeof BackgroundSchema>
